import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2eff3a09"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pagination-wrap" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = { class: "pagination-items" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["disabled"]

import { computed } from 'vue';

enum PaginationItemType {
  number,
  dots,
}

interface PaginationItem {
  type: PaginationItemType,
  page: number,
  isCurrent: boolean,
}

interface Props {
  page?: number;
  pageCount?: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Pagination',
  props: {
    page: { default: 1 },
    pageCount: { default: 1 }
  },
  setup(__props: any) {

const props = __props as { page: number, pageCount: number }



const paginationItems = computed<PaginationItem[]>(() => {
  const {page, pageCount} = props;
  const createPaginationItem = (p: number, type: PaginationItemType = PaginationItemType.number): PaginationItem => ({
    type,
    page: p,
    isCurrent: page === p,
  });
  const createArray = (count: number): number[] => [...Array(count)].map((_, i) => i);

  if (pageCount <= 7) {
    return createArray(pageCount).map((number) => createPaginationItem(number + 1));
  }

  if (page <= 4){
    return [
      ...createArray(5).map((number) => createPaginationItem(number + 1)),
      createPaginationItem(6, PaginationItemType.dots),
      createPaginationItem(pageCount),
    ];
  } if (page > pageCount - 4){
    return [
      createPaginationItem(1),
      createPaginationItem(pageCount - 5, PaginationItemType.dots),
      ...createArray(5).map((number) => createPaginationItem(pageCount - 4 + number)),
    ];
  }
  return [
    createPaginationItem(1),
    createPaginationItem(page - 2, PaginationItemType.dots),
    ...createArray(3).map((number) => createPaginationItem(page - 1 + number)),
    createPaginationItem(page + 2, PaginationItemType.dots),
    createPaginationItem(pageCount),
  ];
});

return (_ctx: any,_cache: any) => {
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "pagination-arrow",
      disabled: __props.page === 1,
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:page', __props.page - 1)))
    }, [
      _createVNode(_component_FontAwesomeIcon, { icon: "long-arrow-alt-left" })
    ], 8, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(paginationItems), (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.page,
          class: _normalizeClass(["pagination-item", {current: item.isCurrent}]),
          onClick: ($event: any) => (_ctx.$emit('update:page', item.page))
        }, [
          (item.type === PaginationItemType.number)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(item.page), 1)
              ], 64))
            : (_openBlock(), _createBlock(_component_FontAwesomeIcon, {
                key: 1,
                icon: "ellipsis-h"
              }))
        ], 10, _hoisted_4))
      }), 128))
    ]),
    _createElementVNode("button", {
      class: "pagination-arrow",
      disabled: __props.page === __props.pageCount,
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:page', __props.page + 1)))
    }, [
      _createVNode(_component_FontAwesomeIcon, { icon: "long-arrow-alt-right" })
    ], 8, _hoisted_5)
  ]))
}
}

})